var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioslashfill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "audio.slash.fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-XR-Copy-2",
    transform: "translate(-41.000000, -489.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    transform: "translate(17.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audio",
    transform: "translate(24.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0273438,22.0585938 C21.390625,22.421875 21.9765625,22.421875 22.328125,22.0585938 C22.6796875,21.6953125 22.6914062,21.1210938 22.328125,20.7578125 L2.39453125,0.8359375 C2.03125,0.47265625 1.4453125,0.47265625 1.08203125,0.8359375 C0.73046875,1.1875 0.73046875,1.78515625 1.08203125,2.13671875 L21.0273438,22.0585938 Z M17.1015625,13.4804688 L17.1015625,2.60546875 C17.1015625,1.65625 16.3867188,0.90625 15.4140625,0.90625 C14.7929688,0.90625 14.3242188,1.15234375 13.65625,1.7734375 L9.56640625,5.5703125 C9.53125,5.60546875 9.484375,5.640625 9.4375,5.640625 L9.25,5.640625 L17.1015625,13.4804688 Z M5.78125,15.9414062 C4,15.9414062 3.0625,14.9804688 3.0625,13.1054688 L3.0625,8.93359375 C3.0625,8.01953125 3.296875,7.31640625 3.73046875,6.84765625 L16.9609375,20.0664062 C16.6914062,20.7460938 16.140625,21.109375 15.4257812,21.109375 C14.78125,21.109375 14.2773438,20.8632812 13.65625,20.2773438 L9.09765625,16.0234375 C9.02734375,15.9648438 8.95703125,15.9414062 8.86328125,15.9414062 L5.78125,15.9414062 Z",
    id: "audio.slash.fill"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioslashfill);
export default __webpack_public_path__ + "static/media/audio.slash.fill.df208d32f4bf8e3a88fe0a1038338e38.svg";
export { ForwardRef as ReactComponent };